import { useState } from 'react'
import { X, Search, Check } from 'react-feather'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  Card,
  CardBody
} from 'reactstrap'

const AddressBookModal = ({ isOpen, onClose, addresses = [], onSelect, selectedAddress }) => {
  const [searchQuery, setSearchQuery] = useState('')

  const filteredAddresses = addresses.filter(address => {
    if (!searchQuery) return true
    const searchLower = searchQuery.toLowerCase()
    const searchTerms = searchLower.split(' ').filter(term => term.length > 0)

    const addressFields = [
      address.full_name,
      address.company_name,
      address.address_line_1,
      address.address_line_2,
      address.city,
      address.state,
      address.zip_code,
      address.address_phone
    ]
      .filter(Boolean)
      .map(field => field.toLowerCase())

    return searchTerms.every(term => addressFields.some(field => field.includes(term)))
  })

  const handleSelect = address => {
    onSelect(address)
    onClose()
  }

  const handleClose = () => {
    setSearchQuery('')
    onClose()
  }

  const AddressCard = ({ address }) => {
    const isSelected = selectedAddress?.id === address.id

    return (
      <Card
        className={`mf-mb-2 ${isSelected ? 'border-primary bg-light' : ''}`}
        style={{ cursor: 'pointer' }}
        onClick={() => handleSelect(address)}
      >
        <CardBody className="d-flex justify-content-between align-items-start mf-py-3">
          <div className="flex-grow-1" data-jam-blur>
            <p className="fw-bold mf-mb-1">
              {address.full_name}
              {address.company_name && <span className="fw-normal">, {address.company_name}</span>}
            </p>
            <p className="text-muted mf-mb-0 small">{address.address_line_1}</p>
            {address.address_line_2 && <p className="text-muted mf-mb-0 small">{address.address_line_2}</p>}
            <p className="text-muted mf-mb-0 small">
              {address.city}, {address.state} {address.zip_code}
            </p>
            {address.address_phone && <p className="text-muted mf-mb-0 small mf-mt-1">{address.address_phone}</p>}
          </div>
          {isSelected && (
            <div className="text-primary mf-ms-3">
              <Check size={20} />
            </div>
          )}
        </CardBody>
      </Card>
    )
  }

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="lg" centered>
      <ModalHeader toggle={handleClose}>Select Address from Address Book</ModalHeader>

      <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {/* Search Input */}
        {addresses.length > 3 && (
          <InputGroup className="mf-mb-3">
            <InputGroupText className="mf-bg-white">
              <Search size={16} className="text-muted" />
            </InputGroupText>
            <Input
              data-jam-blur
              type="text"
              placeholder="Search addresses..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </InputGroup>
        )}

        {/* Address List */}
        {filteredAddresses.length === 0 ? (
          <div className="mf-text-center text-muted mf-py-5">
            {searchQuery ? 'No addresses match your search.' : 'No addresses available.'}
          </div>
        ) : (
          filteredAddresses.map(address => <AddressCard key={address.id} address={address} />)
        )}
      </ModalBody>

      <ModalFooter>
        <Button className="mf-outline-btn" onClick={handleClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddressBookModal
